import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { AppConfig, primeNGConfig } from '@shared/utils/app-config';
import { environment } from '../environments/environment';
import { ErrorCodes } from '@shared/feature/forms';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { errorMessages } from '../../../shared/assets/errors/error-codes';
import { IntrensicShellModule } from '@intrensic/shell';
import { ErrorHandlerService, ApplicationInsightsService } from '@shared/utils/logging';
import { SharedFeatureTabsModule } from '@shared/feature/tabs';
import { B2cConfig } from '@shared/feature/b2c-auth';
import { BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { SharedFeatureTranslateModule } from '@shared/feature/translate';
import { providePrimeNG } from 'primeng/config';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

const b2cConfiguration: B2cConfig = {
  auth: {
    clientId: environment.b2cConfig.clientId,
    authority: environment.b2cConfig.authority,
    knownAuthorities: [environment.b2cConfig.knownAuthorities],
    redirectUri: environment.b2cConfig.redirectUri,
    postLogoutRedirectUri: environment.b2cConfig.postLogoutRedirectUri,
    navigateToLoginRequestUrl: environment.b2cConfig.navigateToLoginRequestUrl,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string): void {
        // eslint-disable-next-line no-console
        console.log(message);
      },
      logLevel: LogLevel.Error,
      piiLoggingEnabled: !environment.production,
    },
  },
  b2cApiScope: environment.b2cConfig.b2cApiScope,
  b2cNewApiScope: environment.b2cConfig.b2cNewApiScope,
  b2cScopes: [...environment.b2cConfig.b2cScopes, environment.b2cConfig.b2cApiScope],
};

@NgModule({
  declarations: [AppComponent],
  imports: [IntrensicShellModule, BrowserModule, RouterModule, SharedFeatureTabsModule, SharedFeatureTranslateModule, BrowserAnimationsModule],
  providers: [
    ApplicationInsightsService,
    { provide: AppConfig, useValue: environment },
    { provide: ErrorCodes, useValue: errorMessages },
    { provide: B2cConfig, useValue: b2cConfiguration },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    providePrimeNG(primeNGConfig),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
